import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';

import AdvancedHotkey from './component';

import { prepareToOpenNewOrderModal } from '../../../store/orders/edit-order/edit.order.actions';
import Global from '../../../store/global-selectors';
import { useUserHasOrderViewRestriction, useUserHasOrderManagementRole } from '../../../hooks/use-user-role';

export const messages = defineMessages({
  name: {
    description: 'create new order hotkey',
    defaultMessage: 'Create new order',
    id: 'OrETqD',
  },
});

export const hotkey = ['n'];
export const barcodeContent = '+U36B7U2MJ9JT=';

const CreateNewOrderHotkey = ({ children }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const userHasActiveManualStore = useSelector(Global.selectSellerActiveManualStores)?.length > 0;
  const userHasOrderViewRestriction = useUserHasOrderViewRestriction();
  const userHasOrderManagementRole = useUserHasOrderManagementRole();
  const canCreateNewOrder = userHasActiveManualStore && !userHasOrderViewRestriction && userHasOrderManagementRole;
  const onUpdate = useCallback(() => {
    dispatch(prepareToOpenNewOrderModal());
  }, [dispatch]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: hotkey,
      hotkey,
      handler: onUpdate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onUpdate],
  );
  if (!canCreateNewOrder) {
    return children;
  }
  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

CreateNewOrderHotkey.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CreateNewOrderHotkey;
